import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Alert } from '@mui/material';
import { styled } from '@mui/material/styles';
import { FormattedMessage } from 'react-intl';

const SUPPORT_EMAIL = 'sales.operations@rubyplay.com';
const SUPPORT_EMAIL_MAILTO = `mailto:${SUPPORT_EMAIL}`;

export const FILES_ACCESSIBILITY_BANNER_PATHS = [
  '/games',
  '/compliance',
  '/marketing',
] as const;

export const shouldShowFilesAccessibilityBanner = (
  pathname: string,
) =>
  FILES_ACCESSIBILITY_BANNER_PATHS.includes(
    pathname as (typeof FILES_ACCESSIBILITY_BANNER_PATHS)[number],
  );

const bannerColors = {
  background: '#E5F6FD',
  text: '#014361',
  icon: '#0288D1',
  border: 'rgba(2, 136, 209, 0.25)',
} as const;

const FilesAccessibilityInfoBanner = () => (
  <BannerRoot>
    <BannerInner className="page-width-wrapper">
      <StyledAlert icon={<InfoOutlinedIcon />} severity="info">
        <FormattedMessage
          id="filesAccessibilityBanner.message"
          defaultMessage="As part of ongoing improvements, some files may be temporarily inaccessible. Our team is actively working to minimize disruption. For assistance, contact {email}."
          values={{
            email: (
              <EmailLink href={SUPPORT_EMAIL_MAILTO}>
                {SUPPORT_EMAIL}
              </EmailLink>
            ),
          }}
        />
      </StyledAlert>
    </BannerInner>
  </BannerRoot>
);

const EmailLink = styled('a')({
  color: 'inherit',
  fontWeight: 500,
  textDecoration: 'underline',
});

const BannerRoot = styled('div')(() => ({
  width: '100%',
  marginTop: 0,
  backgroundColor: bannerColors.background,
  borderBottom: `1px solid ${bannerColors.border}`,
  boxSizing: 'border-box',
}));

const BannerInner = styled('div')(({ theme }) => ({
  padding: theme.spacing(1.5, 4),
  boxSizing: 'border-box',
}));

const StyledAlert = styled(Alert)({
  backgroundColor: 'transparent',
  color: bannerColors.text,
  border: 'none',
  borderRadius: 0,
  margin: 0,
  padding: 0,
  alignItems: 'flex-start',
  '& .MuiAlert-icon': {
    color: bannerColors.icon,
    paddingTop: 2,
  },
  '& .MuiAlert-message': {
    padding: 0,
    fontSize: 14,
    lineHeight: '20px',
  },
});

export default FilesAccessibilityInfoBanner;
